import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon, Alert } from "react-bootstrap";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import TextoInput from "../../../general/componentes/TextoInput";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { ComplementosFecha } from "../../config_general/modelo/ComplementosFecha";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { FiltroAdminServicios, Servicio } from "../modelo/AdminServicio";
import { consultarServicios as consultarServicios, limpiarMensajesServicio, ventanaAyudaServicio } from "../modulos/adminServicioActions";
import TablaAdminServicios from "./TablaAdminServicios";
import InterruptorSN from "../../config_general/componentes/InterruptorSN";
import { ClaveSNServicio } from "../modelo/ClaveSNServicio";
import { TipoFechaServicio } from "../modelo/TipoFechaServicio";
import ConsultarReporteXLS from "../../descarga_reporte/componentes/ConsultarReporteXLS";
import { TipoReportes } from "../../descarga_reporte/modelo/TiposReporte";
import { descargarReporteXLS } from "../../descarga_reporte/modulos/descargaReporteActions";
import TiposTransacciones from "../../../general/componentes/TiposTransacciones";
import { consultarMaestroTransaccionesSat } from "../../../general/modulos/maestrosActions";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { complementoFechaServicio, fechaServicio, servicio, textoCoincidenciaServicio, tipoFechaServicio, tipoProcesoServicio, valorProcesoSiNo } from "../../config_general/modelo/TextosAyuda";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaServicio } from "../../config_general/modelo/TextoVentanaAyuda";

class AdministradorServicios extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            ventanaAyuda: true,
            showAlert: true,
            enableInput: false
        };
    }

    componentWillMount() {
        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        }

        const ventanaDesplegada = this.props.ventanaAyudaServicio;
        ventanaDesplegada ? this.setState({ ventanaAyuda: false }) : this.props.dispatch(ventanaAyudaServicio());
    }

    handleDismissAlert() {
        this.setState({ showAlert: false });
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({ showAlert: nextProps.showAlert });
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesServicio());
    }

    render() {
        const { servicios, estado, estadoAccion, mensajeAccion, paginas, tamanoPagina, paginaActual } = this.props;

        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Administración Servicios
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta de servicios</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="consecutivo">Servicio</label>
                                                <TextoAyuda texto={servicio} />
                                                <TiposTransacciones name="consecutivo" placeholder="Seleccione el servicio" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="palabraClave">Texto Coincidencia</label>
                                                <TextoAyuda texto={textoCoincidenciaServicio} />
                                                <TextoInput name="palabraClave" placeholder="Ingrese texto" maxLength={10} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="claveSN">Tipo Proceso</label>
                                                <TextoAyuda texto={tipoProcesoServicio} />
                                                <TextoInputSelector name="claveSN" maestro={this.listaComplementoSN()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="valorSN">Valor Proceso</label>
                                                <TextoAyuda texto={valorProcesoSiNo} />
                                                <InterruptorSN name={"valorSN"} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoFecha">Tipo Fecha</label>
                                                <TextoAyuda texto={tipoFechaServicio} />
                                                <TextoInputSelector name={"tipoFecha"} maestro={this.listaTipoFechaServicio()} />
                                                {errors.tipoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Registro</label>
                                                <TextoAyuda texto={fechaServicio} />
                                                <DatePickerSura name={"fecha"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="complementoFecha">Complemento Fecha</label>
                                                <TextoAyuda texto={complementoFechaServicio} />
                                                <TextoInputSelector name="complementoFecha" maestro={this.listarSignoFechas()} />
                                                {errors.complementoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.complementoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    <ConsultarReporteXLS tipoReporte={TipoReportes.MAESTRO_SERVICIOS} onDescargar={this.descargarXLS} />
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderAlertaAccion(estadoAccion, mensajeAccion)}
                    {this.renderTablaAdminGlosas(servicios, estado, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderAlertaAccion(estadoAccion: REQUEST, mensajeAccion: string) {
        switch (estadoAccion) {
            case REQUEST.SUCCESS:
                return this.state.showAlert && this.renderAlertaExito();
            case REQUEST.ERROR:
                return this.state.showAlert && this.renderAlertaError(mensajeAccion);
            default:
                return false;
        }
    }

    renderAlertaError(mensajeAccion: string) {
        return (
            <Alert bsStyle="danger" onDismiss={() => this.handleDismissAlert()}>
                <h4>ERROR !</h4>
                <p style={{ fontSize: "15px", color: "#a94442" }}>
                    Ocurrió un error realizando la acción. <b>Error:</b> {mensajeAccion}
                </p>
            </Alert>
        );
    }

    renderAlertaExito() {
        return (
            <Alert bsStyle="success" onDismiss={() => this.handleDismissAlert()}>
                <h4>EXITO !</h4>
                <p style={{ fontSize: "15px" }}>
                    La acción se realizó con éxito.
                </p>
            </Alert>
        );
    }

    renderTablaAdminGlosas(servicios: Array<Servicio>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!servicios || !servicios.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado servicios"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaAdminServicios
                                servicios={servicios}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaServicio}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color: "#000000" }}>Por medio de esta ventana podrás consultar o exportar a un archivo de Excel los servicios configurados,
                    luego de consultarlos se tiene la opción de crear o actualizar un servicio,
                    opciones que se encuentran en la columna de Acción.
                    <br />
                    <br />
                    Es <strong style={{ color: "#e57777" }}>importante</strong> antes de realizar cualquier modificación sobre un servicio tener en cuenta que
                    este cumple una función dentro de la aplicación lo que podría llevar a la generación de errores, desconfiguración o comportamiento
                    inesperado de la aplicación.
                    <br />
                    <br />
                    Se recomienda antes de modificarlos consultar con TI el impacto de cambiar el servicio o sus valores.
                </p>
            </ModalAyudaVentana >
        );
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    filtros(): FiltroAdminServicios {
        return {
            consecutivo: this.state.consecutivo,
            palabraClave: this.state.palabraClave,
            claveSN: this.state.claveSN,
            valorSN: this.state.valorSN,
            tipoFecha: this.state.tipoFecha,
            fecha: this.state.fecha,
            complementoFecha: this.state.complementoFecha
        };
    }

    consultaPaginada = (filtro: FiltroAdminServicios) => {
        this.props.dispatch(consultarServicios(filtro));
    };

    onSubmit = (values: any) => {
        const consecutivo = values.consecutivo ? Number(values.consecutivo) : undefined;
        const palabraClave = values.palabraClave ? values.palabraClave.valueOf() : undefined;
        const claveSN = values.claveSN ? values.claveSN.value : undefined;
        const valorSN = values.valorSN ? "S" : "N";
        const tipoFecha = values.tipoFecha ? values.tipoFecha.valueOf() : undefined;
        const fecha = values.fecha ? values.fecha.valueOf() : undefined;
        const complementoFecha = values.complementoFecha ? Number(values.complementoFecha.value) : undefined;

        const filtro: FiltroAdminServicios = {
            consecutivo: consecutivo,
            palabraClave: palabraClave,
            claveSN: claveSN,
            valorSN: valorSN,
            tipoFecha: tipoFecha,
            fecha: fecha,
            complementoFecha: complementoFecha,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            consecutivo: consecutivo,
            palabraClave: palabraClave,
            claveSN: claveSN,
            valorSN: valorSN,
            tipoFecha: tipoFecha,
            fecha: fecha,
            complementoFecha: complementoFecha,
            filtro: filtro
        });

        this.props.dispatch(consultarServicios(filtro));
    };

    validate = (values: any) => {
        const errors = {
            tipoFecha: undefined,
            fecha: undefined,
            complementoFecha: undefined
        };

        if (values.tipoFecha || values.fecha || values.complementoFecha) {
            errors.tipoFecha = values.tipoFecha ? undefined : "Por favor seleccione una de las opciones";
            errors.fecha = values.fecha ? undefined : "Por favor seleccione una fecha";
            errors.complementoFecha = values.complementoFecha ? undefined : "Por favor seleccione una de las opciones";

        }

        return errors;
    };

    listarSignoFechas = () => {
        return [].concat(
            ComplementosFecha.map(value => ({
                value: value.codigo,
                label: value.nombre
            })
            ));
    }

    listaComplementoSN = () => {
        return [].concat(
            ClaveSNServicio.map(value => ({
                value: value.nombreEnvio,
                label: value.nombreProceso
            })
            ));
    }

    listaTipoFechaServicio = () => {
        return [].concat(
            TipoFechaServicio.map(value => ({
                value: value.nombreEnvio,
                label: value.nombreProceso
            })
            ));
    }

    descargarXLS = (tipo: TipoReportes) => {
        this.props.dispatch(descargarReporteXLS(tipo));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        estado: R.pathOr([], ["administrador_servicios", "estado"])(store),
        estadoAccion: R.pathOr([], ["administrador_servicios", "estadoAccion"])(store),
        mensajeAccion: R.pathOr([], ["administrador_servicios", "mensajeAccion"])(store),
        showAlert: R.pathOr([], ["administrador_servicios", "showAlert"])(store),
        servicios: R.pathOr([], ["administrador_servicios", "servicios"])(store),
        paginas: R.pathOr([], ["administrador_servicios", "paginas"])(store),
        paginaActual: R.pathOr([], ["administrador_servicios", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["administrador_servicios", "tamanoPagina"])(store),
        totalParametrosConsulta: R.pathOr([], ["administrador_servicios", "totalParametrosConsulta"])(store),
        ventanaAyudaServicio: R.pathOr(undefined, ["administrador_servicios", "ventanaAyudaServicio"])(store)
    };
})(AdministradorServicios);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/componentes/AdministradorServicios.tsx